var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadable | relative flex-1 overflow-y-auto",class:{ 'loading': _vm.loading }},[_c('div',{staticClass:"p-8"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }